<h3 matDialogTitle>{{ 'GNR_ADD_CONTEXT_DOC' | translate }}</h3>
<button class="close-btn" mat-icon-button matDialogClose>
  <mat-icon>close</mat-icon>
</button>
<mat-divider></mat-divider>
<mat-dialog-content>
  <p class="create-new-subtitle">
    {{ 'GNR_ADD_CONTEXT_DOC_DIALOG_SUBTITLE' | translate }}
  </p>

  <div class="type-cards">
    @for (option of typeOptions; track option.docType) {
      <button
        class="type-card"
        [ngClass]="option.themeClass"
        [class.type-card--selected]="selectedType() === option.docType"
        (click)="selectType(option.docType)">
        {{ option.labelKey | translate }}
      </button>
    }
  </div>

  @let hasType = !!selectedType();
  <div
    class="dropzone"
    role="button"
    [tabindex]="hasType ? 0 : -1"
    [class.dropzone--dragging]="isDragging()"
    [class.dropzone--disabled]="!hasType"
    (drop)="onDrop($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (click)="hasType && fileInputRef.nativeElement.click()"
    (keydown.enter)="hasType && fileInputRef.nativeElement.click()">
    <mat-icon>cloud_upload</mat-icon>
    <p class="dropzone__title">
      {{
        (hasType
          ? 'GNR_CONTEXT_DOC_DROPZONE_TITLE'
          : 'GNR_CONTEXT_DOC_SELECT_TYPE_FIRST'
        ) | translate
      }}
    </p>
    <button
      mat-stroked-button
      [disabled]="!hasType"
      (click)="$event.stopPropagation(); fileInputRef.nativeElement.click()">
      {{ 'CMD_FILE_SELECT' | translate }}
    </button>
  </div>
</mat-dialog-content>

<input #fileInput type="file" hidden (change)="onFileInputChange($event)" />
